import App from './App'
import customTabbar from '@/components/custom-tabbar/custom-tabbar.vue'
import rewardResultModal from '@/components/reward-result-modal/reward-result-modal.vue'
import globalLuckyDropHost from '@/components/global-lucky-drop-host/global-lucky-drop-host.vue'

import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'

export function createApp() {
  const app = createSSRApp(App)
  app.use(createPinia())
  app.component('custom-tabbar', customTabbar)
  app.component('reward-result-modal', rewardResultModal)
  app.component('global-lucky-drop-host', globalLuckyDropHost)
  return { app }
}
